// @flow
import { httpClient } from 'angieslist-app-platform';

export type Entitlement = {
  permission: string,
  scope: string,
  scopeId?: string
};
export type UserInfo = {
  userId: string,
  status: string,
  firstName?: string,
  lastName?: string,
  email: string,
  entitlements: Array<Entitlement>,
  userDelegatedServiceProviderIds?: Array<string>
};

export const getUser = (): Promise<{ body: UserInfo }> =>
  httpClient.get('/gateway/office-home/v2/users/current');

export default { getUser };



// WEBPACK FOOTER //
// ./src/app/common/user/userService.js